var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import getElementBoundingRectHOC from '../hoc/getElementBoundingRectHOC';
import FullScreenOverlay from '../fullScreenOverlay/FullScreenOverlay';
import FilterBox from './FilterBox';
import { SELECTOR_WIDTH } from './constants';
import SelectorMenu from './SelectorMenu';
var MENU_ITEM_HEIGHT = 75;
var DEFAULT_MIN_VISIBLE_ITEMS = 3;
var DEFAULT_MAX_VISIBLE_ITEMS = 5;
var Selector = /** @class */ (function (_super) {
    __extends(Selector, _super);
    function Selector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFocused: props.isFocused || false,
        };
        return _this;
    }
    Selector.prototype.componentDidUpdate = function () {
        ReactTooltip.rebuild();
    };
    Selector.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var _d = this.props, name = _d.name, label = _d.label, menuItems = _d.menuItems, disabled = _d.disabled, errorMessage = _d.errorMessage, onItemToggle = _d.onItemToggle, allItemsSelected = _d.allItemsSelected, onSelectAllItems = _d.onSelectAllItems, onDeselectAllItems = _d.onDeselectAllItems, filterKeyword = _d.filterKeyword, displayValue = _d.displayValue, onFilter = _d.onFilter, onFocus = _d.onFocus, onBlur = _d.onBlur, onOutsideClick = _d.onOutsideClick;
        var isFocused = this.state.isFocused;
        var minVisibleItems = this.props.minVisibleItems || DEFAULT_MIN_VISIBLE_ITEMS;
        var maxVisibleItems = this.props.maxVisibleItems || DEFAULT_MAX_VISIBLE_ITEMS;
        var top = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.elementBounding) === null || _b === void 0 ? void 0 : _b.top) !== null && _c !== void 0 ? _c : 0;
        var fromBottom = window.innerHeight - top - 60;
        var openTop = fromBottom - (MENU_ITEM_HEIGHT * minVisibleItems) < 0;
        var maxHeight = Math.min(openTop ? top : fromBottom, maxVisibleItems * MENU_ITEM_HEIGHT);
        var filterBoxValue = isFocused
            ? filterKeyword
            : displayValue;
        return (React.createElement("div", { className: "Selector", style: { width: SELECTOR_WIDTH } },
            React.createElement("div", { className: classNames('Selector__content') },
                isFocused && React.createElement(FullScreenOverlay, { onClick: function () {
                        onOutsideClick && onOutsideClick();
                        _this.setState({ isFocused: false });
                    } }),
                React.createElement(FilterBox, { name: name, label: label, value: filterBoxValue, tooltip: isFocused ? '' : filterBoxValue, onFilter: onFilter, onFocus: function () {
                        onFocus && onFocus();
                        _this.setState({ isFocused: !disabled });
                    }, onBlur: onBlur, isFocused: isFocused, disabled: disabled, errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.trim() }),
                isFocused && React.createElement(SelectorMenu, { name: name, className: classNames({ 'Selector__SelectorMenu--up': openTop }), style: { maxHeight: maxHeight }, allItemsSelected: allItemsSelected, filteredKeyword: this.props.filterKeyword, items: menuItems, onItemToggle: onItemToggle, onSelectAllItems: onSelectAllItems, onDeselectAllItems: onDeselectAllItems }))));
    };
    return Selector;
}(React.Component));
export default getElementBoundingRectHOC(Selector);
//# sourceMappingURL=Selector.js.map